import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useConfigurationContext } from '../../contexts/ConfigurationContext';
import { getCustomAxios } from '../../helpers';
export var useLoginConfigurationQuery = function useLoginConfigurationQuery() {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useConfigurationCont = useConfigurationContext(),
      currentLanguage = _useConfigurationCont.currentLanguage;

  useEffect(function () {
    var getData = async function getData() {
      try {
        var configurationResponse = await getCustomAxios(currentLanguage).get('/system/ajax/LoginApi/GetConfiguration');
        setData(configurationResponse.data);
      } catch (error) {
        setData(undefined);
      }
    };

    getData();
  }, [currentLanguage]);
  return data;
};